import {
    CLEAR_REPORTS,
    GET_DOCUMENT_TRAIL_REPORT,
    GET_DOCUMENT_TRAIL_REPORT_FAILED,
    GET_DOCUMENT_TRAIL_REPORT_SUCCESS,
    GET_INVOICE_REPORT,
    GET_INVOICE_REPORT_FAILED,
    GET_INVOICE_REPORT_SUCCESS,
    GET_MASTER_VIEW_REPORT,
    GET_MASTER_VIEW_REPORT_FAILED,
    GET_MASTER_VIEW_REPORT_SUCCESS,
    GET_STATISTIC_REPORT,
    GET_STATISTIC_REPORT_FAILED,
    GET_STATISTIC_REPORT_SUCCESS,
    GET_USER_AUDIT_TRAIL_REPORT,
    GET_USER_AUDIT_TRAIL_REPORT_FAILED,
    GET_USER_AUDIT_TRAIL_REPORT_SUCCESS,
    GET_USER_MANAGEMENT_REPORT,
    GET_USER_MANAGEMENT_REPORT_FAILED,
    GET_USER_MANAGEMENT_REPORT_SUCCESS,

    GET_MASS_UPDATE_LOG,
    GET_MASS_UPDATE_LOG_FAILED,
    GET_MASS_UPDATE_LOG_SUCCESS,
} from './constants';

type Action = { type: string, payload: {} | string };

export const clearReport = (): Action => ({
    type: CLEAR_REPORTS,
    payload: {},
});

//////////////// STATISTIC REPORT ////////////////
export const getStatisticReport = (page, sizePerPage, filter): Action => ({
    type: GET_STATISTIC_REPORT,
    payload: {page, sizePerPage, filter},
});

export const getStatisticReportSuccess = (response: Object): Action => ({
    type: GET_STATISTIC_REPORT_SUCCESS,
    payload: response,
});

export const getStatisticReportFailed = (error: string): Action => ({
    type: GET_STATISTIC_REPORT_FAILED,
    payload: error,
});

export const getInvoiceReport = (page, sizePerPage, filter): Action => ({
    type: GET_INVOICE_REPORT,
    payload: {page, sizePerPage, filter},
});

export const getInvoiceReportSuccess = (response: Object): Action => ({
    type: GET_INVOICE_REPORT_SUCCESS,
    payload: response,
});

export const getInvoiceReportFailed = (error: string): Action => ({
    type: GET_INVOICE_REPORT_FAILED,
    payload: error,
});

export const getUserManagement = (page, sizePerPage, filter): Action => ({
    type: GET_USER_MANAGEMENT_REPORT,
    payload: {page, sizePerPage, filter},
});

export const getUserManagementSuccess = (response: Object): Action => ({
    type: GET_USER_MANAGEMENT_REPORT_SUCCESS,
    payload: response,
});

export const getUserManagementFailed = (error: string): Action => ({
    type: GET_USER_MANAGEMENT_REPORT_FAILED,
    payload: error,
});

export const getUserAuditTrail = (page, sizePerPage, filter): Action => ({
    type: GET_USER_AUDIT_TRAIL_REPORT,
    payload: {page, sizePerPage, filter},
});

export const getUserAuditTrailSuccess = (response: Object): Action => ({
    type: GET_USER_AUDIT_TRAIL_REPORT_SUCCESS,
    payload: response,
});

export const getUserAuditTrailFailed = (error: string): Action => ({
    type: GET_USER_AUDIT_TRAIL_REPORT_FAILED,
    payload: error,
});

export const getDocumentAuditTrail = (page, sizePerPage, filter): Action => ({
    type: GET_DOCUMENT_TRAIL_REPORT,
    payload: {page, sizePerPage, filter},
});

export const getDocumentAuditTrailSuccess = (response: Object): Action => ({
    type: GET_DOCUMENT_TRAIL_REPORT_SUCCESS,
    payload: response,
});

export const getDocumentAuditTrailFailed = (error: string): Action => ({
    type: GET_DOCUMENT_TRAIL_REPORT_FAILED,
    payload: error,
});

export const getMasterViewReport = (page, sizePerPage, filter): Action => ({
    type: GET_MASTER_VIEW_REPORT,
    payload: {page, sizePerPage, filter},
});

export const getMasterViewReportSuccess = (response: Object): Action => ({
    type: GET_MASTER_VIEW_REPORT_SUCCESS,
    payload: response,
});

export const getMasterViewReportFailed = (error: string): Action => ({
    type: GET_MASTER_VIEW_REPORT_FAILED,
    payload: error,
});

// Mass Update Log
export const getMassUpdateLog = (filter): Action => ({
    type: GET_MASS_UPDATE_LOG,
    payload: {filter},
});

export const getMassUpdateLogSuccess = (response: Object): Action => ({
    type: GET_MASS_UPDATE_LOG_SUCCESS,
    payload: response,
});

export const getMassUpdateLogFailed = (error: string): Action => ({
    type: GET_MASS_UPDATE_LOG_FAILED,
    payload: error,
});